import { Injectable } from '@angular/core';
import { HttpRequestModel, HttpService } from '../httpservice/http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PotentialJobsWorkingCommentsService {
  HttpRequestModel: HttpRequestModel = new HttpRequestModel();

  constructor(private httpService: HttpService) {}

  //Request to get all potential jobs working comments by job id
  getJobsWithComments(params: object = {}, showLoader = false, hideLoader = false): Observable<any> {
    let queryString = '';
    if (Object.keys(params).length !== 0 && params.constructor === Object) {
      let tempArray: Array<string> = Object.keys(params).reduce((q, key) => {
        q.push(`${key}=${params[key]}`);
        return q;
      }, []);
      queryString = '?' + tempArray.join('&');
    }

    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = `potential_job_working_comments${queryString}`;
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to get all potential jobs working comments by job id
  getPotentialJobsWorkingCommentsByJobId(
    job_id,
    type: string = 'job',
    params: object = {},
    showLoader = false,
    hideLoader = false,
  ): Observable<any> {
    let queryString = '';
    if (Object.keys(params).length !== 0 && params.constructor === Object) {
      let tempArray: Array<string> = Object.keys(params).reduce((q, key) => {
        q.push(`${key}=${params[key]}`);
        return q;
      }, []);
      queryString = '?' + tempArray.join('&');
    }
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = `potential_job_working_comments/${job_id}/${type}${queryString}`;
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to create new potential jobs working comments by job id
  createPotentialJobsWorkingComments(newWorkingComment, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_working_comments/add';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = newWorkingComment;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }
}
